import { MapGroupId } from "../../types";
import img from "../../mapImages/StreetsOfTarkov3D.webp";

const mapData = {
  groupId: MapGroupId.Streets,
  groupName: {
    en: "Streets of Tarkov",
    ru: "Улицы Таркова",
  },
  title: {
    en: "Main 3D",
    ru: "Главная 3D",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
